import { ErrorBoundary, Provider } from '@rollbar/react';
import { isEmpty } from 'lodash';
import { SocketProvider } from 'sonata-platform-components';
import { FeatureHubProvider, GlobalStyle, Notifications } from 'sonata-react-components';

import SharedReportGate from '@/components/reporting/SharedReport/SharedReportGate/SharedReportGate';
import { AuthProvider } from '@/context/AuthProvider';
import config from '@/global/config';
import { ReactIntl, ReactQuery, Theme } from '@/providers';
import { Routes } from '@/router';
import { useGlobalStore } from '@/store/global';
import { getSession } from '@/store/global/session/selectors.ts';

function App() {
  const session = useGlobalStore(getSession);
  const userId = session && !isEmpty(session) ? session.toJSON().user : '';
  const sessionId = session && !isEmpty(session) ? session.toJSON().sessionId : '';
  const userIdFeatureHub =
    session && !isEmpty(session)
      ? session.get('customUser') || session.get('userFrom') || session.get('user')
      : undefined;

  return (
    <FeatureHubProvider apiKey={config.featureHub.apiKey} url={config.featureHub.url} userId={userIdFeatureHub}>
      <Provider config={config.rollbarConfig}>
        <ErrorBoundary>
          <GlobalStyle />
          <Theme theme="light">
            <Notifications portalId="platformV2Notifications" />
            <ReactQuery>
              <AuthProvider>
                <ReactIntl locale="en">
                  <SocketProvider sessionId={sessionId} userId={userId}>
                    <SharedReportGate>
                      <Routes />
                    </SharedReportGate>
                  </SocketProvider>
                </ReactIntl>
              </AuthProvider>
            </ReactQuery>
          </Theme>
        </ErrorBoundary>
      </Provider>
    </FeatureHubProvider>
  );
}

export default App;
